import React from 'react';
import { Button, Result } from 'antd';
import { useDefault } from 'hooks/useDefault';

const Error500: React.FC = () => {
    const { navigation } = useDefault();

    return <Result
        status="403"
        title="403"
        subTitle="Tady nemáte přístup. Zkuste přejít na domovskou stránku."
        extra={<Button type="primary" onClick={() => navigation('/homepage')}>Domovská stránka</Button>}
    />
};

export default Error500;